<template>
  <div id="card">
    <v-container fluid grid-list-xs>
      <v-layout row wrap>
        <v-card min-width="340" max-width="400" class="pa-3">
          <v-layout row wrap>
            <v-flex xs6>
              <img src="../assets/logo.png" class="logo" />
            </v-flex>
            <v-flex xs6>
              <p>Jalisco | <span class="folio">FOLIO #0006 </span></p>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs3 align-self-center>
              <img src="../assets/frida.png" class="persona" />
            </v-flex>
            <v-flex xs9>
              <v-layout row wrap class="date-place">
                <v-flex xs6>
                  15 de Mayo 2018
                </v-flex>
                <v-flex xs6>
                  Guadalajara, Jalisco
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex xs6>
                  Fecha del hecho
                </v-flex>
                <v-flex xs6>
                  Municipio / Estado
                </v-flex>
              </v-layout>
              <v-layout row wrap class="information">
                <v-flex>
                  José Pérez
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex>
                  Nombre legal
                </v-flex>
              </v-layout>
              <v-layout row wrap class="information">
                <v-flex>
                  S/D
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex>
                  Nombre elegido o asumido
                </v-flex>
              </v-layout>
              <v-layout row wrap class="information">
                <v-flex>
                  Vía pública
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex>
                  Lugar donde apareció el cuerpo
                </v-flex>
              </v-layout>
              <v-layout row wrap class="information">
                <v-flex>
                  Gay/Homosexual
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex>
                  Identidad de género/Orientación sexual percibida
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap class="information">
                <v-flex xs4>
                  29 años
                </v-flex>
                <v-flex xs4>
                  Mexicana
                </v-flex>
                <v-flex x4>
                  Estudiante
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex xs4>
                  Edad
                </v-flex>
                <v-flex xs4>
                  Nacionalidad
                </v-flex>
                <v-flex xs4>
                  Ocupación
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap class="information">
                <v-flex xs4>
                  S/D
                </v-flex>
                <v-flex xs4>
                  Baleado
                </v-flex>
                <v-flex xs4>
                  Arma de fuego
                </v-flex>
              </v-layout>
              <hr />
              <v-layout row wrap class="label2">
                <v-flex xs4>
                  Característica diferencial
                </v-flex>
                <v-flex xs4>
                  Estado del cuerpo
                </v-flex>
                <v-flex xs4>
                  Arma
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4 align-self-center>
              <a class="folio label3" href="">http://www.letraese.org.mx</a>
              <p class="label2 nota">Link a nota principal</p>
            </v-flex>
            <v-flex xs8 class="label4">
              <v-layout row wrap>
                <v-flex xs1>
                  Sí
                  <v-checkbox></v-checkbox>
                  <v-checkbox></v-checkbox>
                  <v-checkbox></v-checkbox>
                </v-flex>
                <v-flex xs1 ml-0>
                  No
                  <v-checkbox></v-checkbox>
                  <v-checkbox></v-checkbox>
                  <v-checkbox></v-checkbox>
                </v-flex>
                <v-flex xs10 ml-0>
                  S/D
                  <v-checkbox label="¿Hubo indicios de tortura?"></v-checkbox>
                  <v-checkbox
                    label="¿Hubo indicios de violencia sexual?"
                  ></v-checkbox>
                  <v-checkbox label="¿Hubo detenido?"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <p class="hechos label2 text-xs-center">
              Descripción de los hechos
            </p>
            <p class="descripcion label2">
              Lorem ipsum dolor sit amet consectetur adipiscing elit taciti
              tempor, urna tempus dis integer varius vehicula enim consequat
              morbi convallis, per erat sem turpis risus curabitur lectus neque.
              Erat volutpat ut ullamcorper gravida cursus quisque Lorem ipsum
              dolor sit amet consectetur adipiscing elit taciti tempor, urna
              tempus dis integer varius vehicula enim consequat morbi convallis,
              per erat sem turpis risus curabitur lectus neque. Erat volutpat ut
              ullamcorper gravida cursus quisqu
            </p>
          </v-layout>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {}
};
</script>

<style scoped>
#card {
  font-family: "Open Sans", sans-serif;
}

.logo {
  max-width: 65%;
}

.persona {
  max-width: 80px;
  border-radius: 50%;
}

.v-input.v-input--selection-controls.v-input--checkbox.theme--light {
  margin-top: 0px;
  max-height: 18px;
}
.date-place {
  color: #be3117;
  font-size: 12px;
}

.information {
  font-weight: 900;
  font-size: 12px;
  padding-top: 5px;
}

.label2 {
  font-size: 10px;
}

.label3 {
  font-size: 9px;
  word-wrap: break-word;
}

.folio {
  color: #be3117;
}

.nota {
  font-weight: 900;
}
.hechos {
  background-color: black;
  color: #fff;
  width: 38%;
  margin-bottom: 0px;
  margin-top: 10px;
}

.descripcion {
  background-color: #efefef;
  max-height: 70px;
  overflow: scroll;
  padding: 5px;
}

.v-input >>> .v-icon {
  font-size: 13px;
}

.v-input >>> .v-label {
  font-size: 9px;
  color: black;
  font-weight: 600;
}

.label4 {
  font-size: 9px;
  color: black;
  font-weight: 600;
}

.v-input >>> .v-input--selection-controls__input {
  margin: 0px;
  width: 14px;
}
</style>
